import { createEvent, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
export { setAssetPath } from '@stencil/core/internal/client';

class FirestoreService {
  constructor() {
  }
  async getLevelData(firebaseLib, program) {
    var firebasedb = (firebaseLib != '' && firebaseLib != undefined) ? firebaseLib.firestore() : this.firestore = firebase.firestore();
    const markers = [];
    var searchQuery = program ? firebasedb.collection("gamification").where("program", "==", program).orderBy("order").get() : firebasedb.collection("gamification").orderBy("order").get();
    return await searchQuery
      .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        markers.push(doc.data());
      });
      return markers;
    })
      .catch(function (error) {
      console.log("Error getting documents: ", error);
    });
  }
}

const gnxGamification_en = () => ({
  "gamification.current_level_label": "Current category",
  "gamification.next_level_label": "Next category:",
  "gamification.view_more_label": "More"  
});

const en = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxGamification_en
});

const gnxGamification_es = () => ({
  "gamification.current_level_label": "Nivel actual",
  "gamification.next_level_label": "Siguiente nivel:",
  "gamification.view_more_label": "Ver más"
});

const es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxGamification_es
});

const gnxGamification_fr = () => ({
  "gamification.current_level_label": "Current category",
  "gamification.next_level_label": "Next category:",
  "gamification.view_more_label": "More"  
});

const fr = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxGamification_fr
});

function getComponentClosestLanguage(element) {
  let closestElement = element.closest("[lang]");  
  return closestElement ? closestElement.lang : "es";
}
function fetchLocaleStringsForComponent(componentName, locale) {
  return new Promise((resolve, reject) => {
    resolve(selectLanguaje(locale).default());
  });
}

async function getLocaleComponentStrings(element) {
  let componentName = element.tagName.toLowerCase();
  let componentLanguage = getComponentClosestLanguage(element);
  //console.log("WC Gamification",componentLanguage)
  let strings;
  try {
    strings = await fetchLocaleStringsForComponent(
      componentName,
      componentLanguage
    );
  } catch (e) {
    console.warn(
      `no locale for ${componentName} (${componentLanguage}) loading default locale en.`
    );
    strings = await fetchLocaleStringsForComponent(componentName, "es");
  }
  return strings;
}

function selectLanguaje(locale) {
  //console.log(locale);
  switch (locale) {
    case "es":
      return es;
    case "fr":
      return fr;
    case "en":
      return en;
    default:
      return es;
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const gnxGamificationDetailCss = ":host{display:block}ion-card{border-radius:10px;box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05);-webkit-box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05);-moz-box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05)}";

const GnxGamificationDetail = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.eventBenefitLevel = createEvent(this, "levelBenefitSelected", 7);
    this.show = false;
    this.firestoreService = new FirestoreService();
    this.levelBenefitHandler = this.levelBenefitHandler.bind(this);
    this.currentLanguage = getComponentClosestLanguage(this.element);
    this.fillStringsText();
  }
  async fillStringsText() {
    this.localeStrings = await getLocaleComponentStrings(this.element);
  }
  /**
   * The score watcher implementation
   */
  whenScoreChange(newValue) {
    //console.log("score changed: ", newValue);
    this.show = false;
    this.score = newValue;
    this.calculateCurrentLevel();
  }
  componentDidLoad() {
    this.firestoreService.getLevelData(this.firebasedb, this.program ? this.program : null).then((res) => {
      this.list = res;
      this.calculateCurrentLevel();
    })
      .catch(function (error) {
      console.log("Error getting documents: ", error);
    });
  }
  levelBenefitHandler() {
    this.eventBenefitLevel.emit("loadDetailFull");
    //console.log("this.eventLevelFull");
  }
  async calculateCurrentLevel() {
    var _a, _b;
    if (this.list) {
      this.currentLevel = this.list.filter(level => this.score >= level.lower && this.score <= level.upper)[0];
      this.primaryBenefits = (_a = this.currentLevel) === null || _a === void 0 ? void 0 : _a.benefits.filter(benefit => benefit.isResume == true)[0];
      this.secondaryBenefits = (_b = this.currentLevel) === null || _b === void 0 ? void 0 : _b.benefits.filter(benefit => benefit.isResume == false);
      await sleep(1000);
      this.show = true;
    }
    //console.log("currentLevelInformation", this.score, this.currentLevel, this.primaryBenefits, this.secondaryBenefits, this.all);    
  }
  render() {
    var _a, _b, _c, _d;
    const { localeStrings } = this;
    return (h("div", { class: "gnx-gamification-details" }, this.show ?
      (this.all ?
        h("ion-grid", null, h("ion-row", null, this.secondaryBenefits.map((secondaryBenefit) => h("ion-col", { size: "12", sizeMd: "6" }, h("ion-item", { lines: "none" }, h("ion-label", { class: "ion-no-margin" }, h("h3", { class: "section_title" }, h("strong", null, secondaryBenefit.label[this.currentLanguage])), h("p", { class: "section_description" }, secondaryBenefit.description[this.currentLanguage]))), h("ion-card", null, secondaryBenefit.benefitItem.map((data) => h("gnx-gamification-detail-item", { label: data.label[this.currentLanguage], description: data.description[this.currentLanguage], image: data.image })))))))
        :
          h("ion-grid", null, h("ion-row", null, h("ion-col", { size: "10", offset: "1", offsetMd: "0", sizeMd: "6", class: "ion-text-center" }, h("h6", { class: "gnx-gamification-preview__text" }, localeStrings["gamification.current_level_label"]), h("gnx-gamification-indicator", { lower: (_a = this.currentLevel) === null || _a === void 0 ? void 0 : _a.lower, upper: (_b = this.currentLevel) === null || _b === void 0 ? void 0 : _b.upper, current: this.score, currentLevel: this.currentLevel.label[this.currentLanguage], enableButton: false })), h("ion-col", { size: "12", sizeMd: "6" }, h("ion-row", null, h("ion-col", { size: "8" }, h("ion-item", { lines: "none" }, h("ion-label", { class: "ion-no-margin" }, h("h3", { class: "section_title" }, h("strong", null, (_c = this.primaryBenefits) === null || _c === void 0 ? void 0 : _c.label[this.currentLanguage])), h("p", { class: "section_description" }, (_d = this.primaryBenefits) === null || _d === void 0 ? void 0 : _d.description[this.currentLanguage])))), h("ion-col", { size: "4" }, h("div", { class: "ion-text-end" }, h("ion-button", { color: "primary", shape: "round", fill: "outline", size: "small", onClick: () => this.levelBenefitHandler() }, localeStrings["gamification.view_more_label"], h("ion-icon", { slot: "end", name: "chevron-forward-outline", color: "secondary" }))))), h("ion-card", null, this.primaryBenefits.benefitItem.map((data) => h("gnx-gamification-detail-item", { label: data.label[this.currentLanguage], description: data.description[this.currentLanguage], image: data.image })))))))
      :
        (this.all ?
          h("gnx-gamification-skeleton", { mode: "full" })
          :
            h("gnx-gamification-skeleton", { mode: "detail" }))));
  }
  get element() { return this; }
  static get watchers() { return {
    "score": ["whenScoreChange"]
  }; }
  static get style() { return gnxGamificationDetailCss; }
};

const gnxGamificationDetailItemCss = ":host{display:block}.gnx-gamification-benefit-item-icon{font-size:50px;margin-inline-end:15px}";

const GnxGamificationDetailItem = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return (h(Host, null, h("ion-item", { lines: "none" }, this.image ?
      h("ion-avatar", { slot: "start" }, h("i", { class: "icon ion-home" }), h("img", { src: "{this.image}" }))
      :
        h("ion-icon", { class: "gnx-gamification-benefit-item-icon", name: "information-circle-outline", color: "primary", slot: "start" }), h("ion-label", null, h("h3", null, h("strong", null, this.label)), h("p", null, this.description)))));
  }
  static get style() { return gnxGamificationDetailItemCss; }
};

const gnxGamificationIndicatorCss = ":host{display:block}.gnx-gamification-preview_next_level{font-size:0.7rem;margin:0px;}.gnx-gamification-preview_progressbar{height:20px;border-radius:30px}.gnx-gamification-interval__text{font-size:0.6rem;margin:0px;padding:0px;}.gnx-gamification-preview_progressbar-inner{position:absolute;top:0px;width:100%;white-space:nowrap;overflow:hidden;padding:5px;border-radius:20px}.gnx-gamification-preview_progressbar-label{background:none repeat scroll 0 0 var(--ion-color-primary);border:2px solid #ffffff;border-radius:50%;color:#fff;font-size:0.7rem;font-weight:bold;padding:12px 4px;position:absolute;top:-7px;width:42px;height:42px;text-align:center}";

const GnxGamificationIndicator = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.eventIndicatorLevel = createEvent(this, "levelIndicatorSelected", 7);
    /**
     * The show progress bar label flag
     */
    this.showProgressBar = true;
    /**
     * The color object
     */
    this.colorButton = 'white';
    this.strNextLevel = '';
    this.fillStringsText();
  }
  componentDidLoad() {
    this.currentProgress = (this.lower + this.current) / this.upper;
    this.checkCurrentIcon();
    this.showProgress();
    this.progressLabel = this.element.querySelector('.gnx-gamification-preview_progressbar-label');
    this.insertColor();
  }
  checkCurrentIcon() {
    if (this.currencyIcons) {
      if (this.currentProgress > 0 && this.currentProgress < 50) {
        this.currentIconLevel = this.currencyIcons.level1;
      }
      if (this.currentProgress > 50 && this.currentProgress < 100) {
        this.currentIconLevel = this.currencyIcons.level2;
      }
      if (this.currentProgress > 100 && this.currentProgress < 150) {
        this.currentProgress = this.currencyIcons.level3;
      }
    }
  }
  insertColor() {
    this.text = this.element.querySelector('.gnx-gamification-preview_next_level');
    this.button = this.element.querySelector('ion-button');
    this.text.style.color = this.colorText;
    this.button.style.color = this.colorButton;
  }
  async fillStringsText() {
    this.localeStrings = await getLocaleComponentStrings(this.element);
    this.strNextLevel = await this.localeStrings['gamification.next_level_label'];
  }
  showProgress() {
    const total = this.currentProgress * 100;
    setTimeout(async () => {
      for (let index = 1; index <= total; index++) {
        this.progressBar = index / 100;
        //console.log(this.progressBar);
        await sleep(30);
        this.progressLabel.style.left = (this.progressBar * 100 - 5).toString() + '%';
      }
    }, 300);
  }
  levelIndicatorHandler() {
    if (!this.disabledRedirect) {
      this.eventIndicatorLevel.emit('loadDetail');
    }
    else {
      console.log('redirect disabled');
    }
    //console.log("this.eventLevel");
  }
  render() {
    //  const {localeStrings} = this;
    var _a;
    return (h(Host, null, h("p", { class: "gnx-gamification-preview__text" }, h("ion-button", { shape: "round", fill: "outline", size: "small", disabled: !this.enableButton, onClick: () => this.levelIndicatorHandler() }, ((_a = this.currencyIcons) === null || _a === void 0 ? void 0 : _a.length) > 0 && h("ion-img", { slot: "start", class: "gnx-gamification-preview__text", src: this.currentIconLevel }), this.currentLevel, h("ion-icon", { slot: "end", name: "chevron-forward-outline", color: "secondary" }))), this.showProgressBar ? (h("ion-row", { class: "gnx-gamification-preview__text" }, h("ion-col", { size: "12", offsetMd: "2", sizeMd: "8" }, h("ion-progress-bar", { class: "gnx-gamification-preview_progressbar", value: this.progressBar }), h("div", { class: "gnx-gamification-preview_progressbar-label" }, parseInt((this.currentProgress * 100).toString(), 10), "%")), h("ion-col", { size: "6", offsetMd: "2", sizeMd: "4" }, h("p", { class: "gnx-gamification-interval__text ion-text-start" }, this.lower)), h("ion-col", { size: "6", sizeMd: "4" }, h("p", { class: "gnx-gamification-interval__text ion-text-end" }, this.upper)))) : (''), this.showNextLevel ? (h("p", { class: "gnx-gamification-preview__text gnx-gamification-preview_next_level" }, this.strNextLevel, " ", this.nextLevel)) : (h("div", null))));
  }
  get element() { return this; }
  static get style() { return gnxGamificationIndicatorCss; }
};

const gnxGamificationResumeCss = ":host{display:block}.gnx-gamification-preview__text{text-align:center}";

const GnxGamificationResume = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.eventResumeLevel = createEvent(this, "levelResumeSelected", 7);
    /**
     * The score object
     */
    this.disabledRedirect = false;
    /**
     * The color object
     */
    this.colorText = 'var(--ion-color-medium)';
    /**
     * The color object
     */
    this.colorButton = 'var(--ion-color-medium)';
    /**
     * The show progressBar
     */
    this.showProgressBar = true;
    this.show = false;
    this.firestoreService = new FirestoreService();
    this.levelResumeHandler = this.levelResumeHandler.bind(this);
    this.currentLanguage = getComponentClosestLanguage(this.element);
    this.fillStringsText();
  }
  async fillStringsText() {
    this.localeStrings = await getLocaleComponentStrings(this.element);
  }
  /**
   * The score watcher implementation
   */
  whenScoreChange(newValue) {
    //console.log("score changed: ", newValue);
    this.show = false;
    this.score = newValue;
    this.calculateCurrentLevel();
  }
  /**
   * The icons watcher implementation
   */
  whenCurrencyIconsChange(newValue) {
    this.currencyIcons = newValue;
  }
  componentDidLoad() {
    console.log(this.program ? this.program : null);
    this.firestoreService
      .getLevelData(this.firebasedb, this.program ? this.program : null)
      .then(res => {
      this.list = res;
      this.calculateCurrentLevel();
    })
      .catch(function (error) {
      console.log('Error getting documents: ', error);
    });
  }
  levelResumeHandler() {
    this.eventResumeLevel.emit('levelResume');
  }
  async calculateCurrentLevel() {
    if (this.list) {
      this.currentLevel = this.list.filter(level => this.score >= level.lower && this.score <= level.upper)[0];
      this.nextLevel = this.list[this.currentLevel.order] ? this.list[this.currentLevel.order] : null;
      await sleep(1000);
      this.show = true;
      //console.log("currentLevelInformation", this.score, this.currentLevel , this.nextLevel);
    }
  }
  render() {
    var _a, _b, _c;
    return (h("div", { class: "gnx-gamification-resume" }, this.show ? (h("ion-grid", null, h("ion-row", null, h("ion-col", { size: "12" }, h("gnx-gamification-indicator", { "disabled-redirect": this.disabledRedirect, "color-button": this.colorButton, "color-text": this.colorText, lower: (_a = this.currentLevel) === null || _a === void 0 ? void 0 : _a.lower, upper: (_b = this.currentLevel) === null || _b === void 0 ? void 0 : _b.upper, current: this.score, currentLevel: this.currentLevel.label[this.currentLanguage], currencyIcons: this.currencyIcons, nextLevel: (_c = this.nextLevel) === null || _c === void 0 ? void 0 : _c.name[this.currentLanguage], showNextLevel: this.nextLevel ? true : false, showProgressBar: this.showProgressBar, enableButton: true, onLevelIndicatorSelected: () => this.levelResumeHandler() }))))) : (h("gnx-gamification-skeleton", { mode: "preview" }))));
  }
  get element() { return this; }
  static get watchers() { return {
    "score": ["whenScoreChange"],
    "currencyIcons": ["whenCurrencyIconsChange"]
  }; }
  static get style() { return gnxGamificationResumeCss; }
};

const PreviewSkeleton = () => {
  return (h("ion-grid", { class: "gnx-gamification-skeleton-preview" },
    h("ion-row", null,
      h("ion-col", { size: "12", class: "gnx-gamification-skeleton-preview__header" },
        h("h3", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__text", animated: true, style: { width: "40%", height: "1.2rem" } })),
        h("h3", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__text ion-margin-top", animated: true, style: { width: "100%", height: "2.5rem" } })),
        h("h6", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__text", animated: true, style: { width: "20%" } }))))));
};

const DetailSkeleton = () => {
  return (h("ion-grid", { class: "gnx-gamification-skeleton-detail" },
    h("ion-row", null,
      h("ion-col", { size: "12", sizeMd: "6", class: "gnx-gamification-skeleton-detail-preview  ion-margin-top" },
        h("h3", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__headerText ", animated: true, style: { width: "30%", height: "1rem" } })),
        h("h3", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__headerText ", animated: true, style: { width: "40%", height: "1.2rem" } })),
        h("h3", null,
          h("ion-skeleton-text", { class: "gnx-gamification-skeleton-preview__headerText ", animated: true, style: { width: "100%", height: "2.5rem" } }))),
      h("ion-col", { size: "12", sizeMd: "6" },
        h("ion-item", { lines: "none" },
          h("ion-label", null,
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "30%" } }),
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "50%" } }))),
        h("ion-card", null,
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))))))));
};

const FullSkeleton = () => {
  return (h("ion-grid", { class: "gnx-gamification-skeleton-detail" },
    h("ion-row", null,
      h("ion-col", { size: "12", sizeMd: "6" },
        h("ion-item", { lines: "none" },
          h("ion-label", null,
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "30%" } }),
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "50%" } }))),
        h("ion-card", null,
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))))),
      h("ion-col", { size: "12", sizeMd: "6" },
        h("ion-item", { lines: "none" },
          h("ion-label", null,
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "30%" } }),
            h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "50%" } }))),
        h("ion-card", null,
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))),
          h("ion-item", { lines: "none" },
            h("ion-avatar", { slot: "start" },
              h("ion-skeleton-text", { animated: true })),
            h("ion-label", null,
              h("h3", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "40%" } })),
              h("p", null,
                h("ion-skeleton-text", { class: "gnx-gamification-skeleton-detail__text", animated: true, style: { width: "80%" } })))))))));
};

const gnxGamificationSkeletonCss = ":host{display:block}.gnx-gamification-skeleton-detail__header{text-align:center}.gnx-gamification-skeleton-preview__headerText{margin:0 auto}.gnx-gamification-skeleton-preview__header{text-align:center}.gnx-gamification-skeleton-preview__text{margin:0 auto}.gnx-gamification-skeleton-detail-preview{margin-bottom:16px}ion-card{border-radius:10px;box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05);-webkit-box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05);-moz-box-shadow:0px 5px 10px 0px rgba(11,11,11,0.05)}";

const GnxGamificationSkeleton = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.checkModeAndRender = () => {
      let skeleton;
      switch (this.mode) {
        case "preview":
          skeleton = h(PreviewSkeleton, null);
          break;
        case "detail":
          skeleton = h(DetailSkeleton, null);
          break;
        case "full":
          skeleton = h(FullSkeleton, null);
          break;
      }
      return skeleton;
    };
  }
  render() {
    return h(Host, null, this.checkModeAndRender());
  }
  static get style() { return gnxGamificationSkeletonCss; }
};

const GnxGamificationDetail$1 = /*@__PURE__*/proxyCustomElement(GnxGamificationDetail, [0,"gnx-gamification-detail",{"score":[2],"all":[4],"firebasedb":[8],"program":[1],"firestoreService":[32],"list":[32],"show":[32],"currentLevel":[32],"currentLanguage":[32],"localeStrings":[32],"primaryBenefits":[32],"secondaryBenefits":[32]}]);
const GnxGamificationDetailItem$1 = /*@__PURE__*/proxyCustomElement(GnxGamificationDetailItem, [0,"gnx-gamification-detail-item",{"image":[1],"label":[1],"description":[1]}]);
const GnxGamificationIndicator$1 = /*@__PURE__*/proxyCustomElement(GnxGamificationIndicator, [0,"gnx-gamification-indicator",{"currencyIcons":[8,"currency-icons"],"lower":[2],"upper":[2],"current":[2],"currentLevel":[1,"current-level"],"nextLevel":[1,"next-level"],"showNextLevel":[4,"show-next-level"],"showProgressBar":[4,"show-progress-bar"],"enableButton":[4,"enable-button"],"colorText":[1,"color-text"],"disabledRedirect":[4,"disabled-redirect"],"colorButton":[1,"color-button"],"disabledButton":[4,"disabled-button"],"localeStrings":[32],"currentProgress":[32],"progressBar":[32],"currentIconLevel":[32]}]);
const GnxGamificationResume$1 = /*@__PURE__*/proxyCustomElement(GnxGamificationResume, [0,"gnx-gamification-resume",{"score":[2],"disabledRedirect":[4,"disabled-redirect"],"firebasedb":[8],"colorText":[1,"color-text"],"colorButton":[1,"color-button"],"program":[1],"currencyIcons":[8,"currency-icons"],"showProgressBar":[4,"show-progress-bar"],"firestoreService":[32],"list":[32],"show":[32],"currentLevel":[32],"nextLevel":[32],"currentLanguage":[32],"localeStrings":[32]}]);
const GnxGamificationSkeleton$1 = /*@__PURE__*/proxyCustomElement(GnxGamificationSkeleton, [0,"gnx-gamification-skeleton",{"mode":[1]}]);
const defineCustomElements = (opts) => {
  if (typeof customElements !== 'undefined') {
    [
      GnxGamificationDetail$1,
  GnxGamificationDetailItem$1,
  GnxGamificationIndicator$1,
  GnxGamificationResume$1,
  GnxGamificationSkeleton$1
    ].forEach(cmp => {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};

export { GnxGamificationDetail$1 as GnxGamificationDetail, GnxGamificationDetailItem$1 as GnxGamificationDetailItem, GnxGamificationIndicator$1 as GnxGamificationIndicator, GnxGamificationResume$1 as GnxGamificationResume, GnxGamificationSkeleton$1 as GnxGamificationSkeleton, defineCustomElements };
